import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { AddUrlModalComponent } from './add-url-modal/add-url-modal.component'
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown'
import { HelperService } from '../../../../../services/helper.service'

export type UrlAnalysisType = { id: number; label: string; url: string }
export type ScopeType = 'CREATE' | 'UPDATE'

@Component({
    selector: 'app-analysis-url-manager',
    templateUrl: './analysis-url-manager.component.html',
    styleUrls: ['./analysis-url-manager.component.scss'],
    standalone: false
})
export class AnalysisUrlManagerComponent {
  @Input() urls: UrlAnalysisType[] = []
  @Input() loading: boolean = false
  @Input() hasWritingAccess: boolean = true
  @Input() scope: ScopeType = 'CREATE'
  @Input() set changed(changed: boolean) {
    this._changed = changed
  }
  @Output() changeUrlsEvent: EventEmitter<UrlAnalysisType[]> = new EventEmitter<UrlAnalysisType[]>()

  private _changed: boolean = false

  public constructor(
    private modalService: NgbModal,
    private nzContextMenuService: NzContextMenuService,
  ) {}

  public onAddUrl(): void {
    if (!this.hasWritingAccess) {
      return
    }
    const modalRef: NgbModalRef = this.modalService.open(AddUrlModalComponent, { size: 'md' })
    modalRef.result
      .then((url: UrlAnalysisType): void => {
        this._changed = true
        this.urls.push(url)
        this.changeUrlsEvent.next(this.urls)
      })
      .catch(res => {})
  }

  public onEditUrl(index: number, url: UrlAnalysisType): void {
    if (!this.hasWritingAccess) {
      return
    }
    const modalRef: NgbModalRef = this.modalService.open(AddUrlModalComponent, { size: 'md' })
    modalRef.componentInstance.urlAnalysis = url
    modalRef.result
      .then((newUrl: UrlAnalysisType): void => {
        if (JSON.stringify(url) !== JSON.stringify(newUrl)) {
          this._changed = true
          this.urls.splice(index, 1, newUrl)
          this.changeUrlsEvent.next(this.urls)
        }
      })
      .catch(res => {})
  }

  public onRemoveUrl(index: number): void {
    if (!this.hasWritingAccess) {
      return
    }
    this._changed = true
    this.urls.splice(index, 1)
    this.changeUrlsEvent.next(this.urls)
  }

  public hasChanges(): boolean {
    if (this.scope === 'UPDATE') {
      return this._changed
    }
    return false
  }

  public redirectUrl(url: UrlAnalysisType): void {
    HelperService.clickOnUrl(url.url, '_blank')
  }

  public contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.nzContextMenuService.create($event, menu)
  }

  closeMenu(): void {
    this.nzContextMenuService.close()
  }
}
